enum InstallmentTypeEnum {
  Deal = 'PA',
  Contract = 'PC',
}

export default InstallmentTypeEnum
